import classNames from 'classnames';
import React from 'react';
import EditingContext from 'store/editingContext';
import ProfilesSection from 'components/import/Profiles';
import SaveSection from 'components/import/Save';
import Session from 'store/session';
import LoginLine, { LoggedInLine } from 'components/account/LoginLine';

import 'components/import/ImportPane.scss';

export default function BuilderSettings() {
  const [editing, setEditing] = EditingContext.useState("builderEditing", true);
  const setSettings = EditingContext.useStateSetter("builderSettings");
  const onClose = React.useCallback(() => setSettings(false), [setSettings]);
  const toggleEditing = React.useCallback(() => setEditing(e => !e), [setEditing]);
  const loggedIn = Session.useSelector(store => !!store.userName);

  return (
    <div className="lap-BuilderSettings">
      <div className="lap-BuilderBlockHeader lap-separator">
        Settings
        <span className="lap-close" onClick={onClose}/>
      </div>
      <div className="lap-body">
        <p>
          <span onClick={toggleEditing}>
            <span className={classNames("lap-toggle", {"lap-active": editing})}/> Editing Mode
          </span>
        </p>
        {loggedIn ? <LoggedInLine/> : <LoginLine suffix=" to track your saved profiles"/>}
        <div className="lap-TabContent lap-ImportPane">
          {!!editing && (
            <div className="lap-Section lap-expanded lap-always">
              <h3>Save</h3>
              <SaveSection builder/>
            </div>
          )}
          {!!loggedIn && (
            <div className="lap-Section lap-expanded lap-always">
              <h3>My Profiles</h3>
              <ProfilesSection builder/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
